<template>
  <SimpleModuleDashboard
    :module-id="Modules.SERVICIOS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="actions"
    :widget-groups="widgetGroups"
    :widget-tabs="widgetTabs"
    tabs-storage-key="tabs_view_dashboard_services"
    :widget-filter="filterWidgets"
  />
</template>

<script>
import Session from '@/handler/session'
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Helper from '@/handler/helper'
import Param from '@/config/parameters'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    integrateServices: Helper.hasParametersAccess(Param.P59),
    actions: [
      { id: 'crudCategory', reference: 'crudCategory', route: 'ServicesStaffCrudCategory', tone: 'primary', group: 'Configuraciones' },
      { id: 'crudServices', reference: 'crudServices', route: 'ServicesStaffCrudServices', tone: 'secondary', group: 'Configuraciones' },
      { id: 'crudServicesCustomers', reference: 'crudServicesCustomers', route: 'ServicesStaffCrudServicesCustomers', tone: 'success' },
      { id: 'displayServicesCustomers', reference: 'displayServicesCustomers', route: 'ServicesStaffDisplayServicesCustomers', tone: 'warning' },
    ],
    widgetTabs: [
      { key: 'main', title: 'General' },
      { key: 'control', title: 'Control' },
    ],
    widgetGroups: {
      main: [
        'list_services',
        'list_next_services_expiration',
        'list_next_services_expiration_with_notification',
        'list_services_customers_from_lead',
      ],
      control: [
        'list_services_customers_details_without_activity',
        'list_services_customers_activity_without_details',
        'list_services_customers_details_diferent_activity',
        'list_services_customers_linkable_without_link',
        'list_services_customers_without_purchase',
      ],
    },
  }),
  computed: {
    isProcessSalesFlow() {
      const modules = Session.getSession().auth.user.permissions.modules || []
      return modules.some(module => module.id === Modules.FLUJO_VENTAS)
    },
  },
  methods: {
    filterWidgets(widget) {
      if (widget.reference === 'list_services_customers_from_lead') return this.isProcessSalesFlow
      // la vinculación a servidores / instancias existe solo con servicios integrados
      if (widget.reference === 'list_services_customers_linkable_without_link') return this.integrateServices
      return true
    },
  },
}
</script>
